import * as actions from './group.actions';
import { EntityState, createEntityAdapter, Update } from '@ngrx/entity';
import { createFeatureSelector, createSelector, Store } from '@ngrx/store';
import { GroupBaseModel } from '@smarttask-common/src/lib/models/Group/Core/GroupBaseModel';

export const groupAdapter = createEntityAdapter<GroupBaseModel>({
    selectId: (x) => x.group_id,
});
export interface GroupState extends EntityState<GroupBaseModel> {
    selected_group_id: number;
}

export const initialState: GroupState = groupAdapter.getInitialState({
    selected_group_id: undefined,
});

export function GroupReducers(state: GroupState = initialState, action: actions.GroupActions) {
    switch (action.type) {
        case actions.GroupActionTypes.UPDATE_SELECTED_ID:
            state = { ...state, selected_group_id: action.selected_group_id };
            //console.log(state);
            return state;

        case actions.GroupActionTypes.ADD_GROUP:
            return groupAdapter.addOne(action.group, state);

        case actions.GroupActionTypes.ADD_GROUPS:
            return groupAdapter.addMany(action.groups, state);

        case actions.GroupActionTypes.UPSERT_GROUP:
            return groupAdapter.upsertOne(action.group, state);

        case actions.GroupActionTypes.UPSERT_GROUPS:
            return groupAdapter.upsertMany(action.groups, state);

        case actions.GroupActionTypes.UPDATE_GROUP:
            return groupAdapter.updateOne(action.group, state);

        case actions.GroupActionTypes.UPDATE_GROUPS:
            return groupAdapter.updateMany(action.groups, state);

        case actions.GroupActionTypes.DELETE_GROUP:
            // if(state.selectedGroupId == action.id){
            //   state.selectedGroupId = undefined;
            // }
            return groupAdapter.removeOne(action.id, state);

        case actions.GroupActionTypes.DELETE_GROUPS:
            // if(action.ids.indexOf(state.selectedGroupId) > -1){
            //   state.selectedGroupId = undefined;
            // }
            return groupAdapter.removeMany(action.ids, state);

        case actions.GroupActionTypes.DELETE_ALL_GROUPS:
            return groupAdapter.removeMany(action.ids, state);

        case actions.GroupActionTypes.DELETE_ALL:
            return groupAdapter.removeAll(state);

        default:
            return state;
    }
}

export const getGroupState = createFeatureSelector<GroupState>('group');

export const { selectIds, selectEntities, selectAll, selectTotal } = groupAdapter.getSelectors(getGroupState);

const getSelectedGroupIdState = (state: GroupState) => {
    return state.selected_group_id;
};
export const getSelectedGroupId = createSelector(getGroupState, getSelectedGroupIdState);

export const getSelectedGroup = createSelector(getGroupState, (state: GroupState) => {
    if (state.selected_group_id == undefined) {
        return undefined;
    }
    return state.entities[state.selected_group_id];
});